import { render, staticRenderFns } from "./position-dialog.vue?vue&type=template&id=59fa61e2&"
import script from "./position-dialog.vue?vue&type=script&lang=js&"
export * from "./position-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports